import { deepClone } from '@shared/utils/objects'

export default {
  install: (app) => {
    app.config.globalProperties.$deepClone = function (object) {
      try {
        return deepClone(object)
      } catch (err) {
        app.$log.debug(err)
      }
    }
  }
}
